import React from 'react';
import { Typography } from '@mui/material';
import { styled } from "@mui/material/styles";

import CustomAccordion from '../accordion/CustomAccordion';
import Stack from '@mui/material/Stack';

var _ = require('lodash');


const StyledTypography = styled(Typography)`
color: ${({ theme }) => theme.palette.primary.contrastText};
font-weight: bold;
`;

export default function Suggestions(props) {
    const { data } = props



    return (
        <React.StrictMode>
            <Stack spacing={2}>
                <StyledTypography
                    align="center"
                    color="textPrimary"
                    variant="h2"
                >
                    {data}
                </StyledTypography>
                <CustomAccordion label={`Based on your Segment`} />
                <CustomAccordion label={`Based on your Market `} />
                <CustomAccordion label={`Based on your Job Function `} />
            </Stack>
        </React.StrictMode>

    )
}
